function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "icon-tertiary",
  x: 9.495,
  y: 18.555,
  width: 22.957,
  height: 14.006,
  fill: "#fff",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.542 29.36 5.5788-2.1344 5.658 1.6008 5.4223-4.2686",
  fill: "none",
  stroke: "#002060"
}), React.createElement("g", {
  className: "icon-secondary",
  transform: "matrix(.20316 0 0 .20009 1.6733 13.052)",
  fill: "#adb9ca",
  fillRule: "evenodd",
  strokeWidth: 4.9598
}, React.createElement("path", {
  d: "m104.5 79c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m49.5 80.903c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029-1.57 3.4029-3.5 3.4029-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m76.5 70.5c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
})), React.createElement("path", {
  className: "icon-primary",
  d: "m28.389 24.457c0-0.38678 0.30937-0.70031 0.69135-0.70031 0.38197 0 0.69135 0.31354 0.69135 0.70031s-0.30937 0.70031-0.69135 0.70031-0.69135-0.31354-0.69135-0.70031z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.20316 0 0 .20009 -.56955 3.3565)",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 4.9598
}, React.createElement("path", {
  d: "m115.54 127.46c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m60.54 129.36c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029c0 1.8792-1.57 3.4029-3.5 3.4029s-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m87.54 118.96c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
}), React.createElement("path", {
  d: "m142.54 105.46c0-1.933 1.5228-3.5 3.4029-3.5s3.4029 1.567 3.4029 3.5-1.5228 3.5-3.4029 3.5-3.4029-1.567-3.4029-3.5z"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m15.087 23.932c-5.5416-1.5719-8.7514-7.31-7.1693-12.816 0.56209-1.9553 1.6902-3.7033 3.2445-5.0266l6.7896 7.8734z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m24.885 6.2135c4.3071 3.8042 4.6952 10.358 0.86606 14.637-2.664 2.9776-6.8096 4.1752-10.665 3.0807l2.8658-9.9689z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m11.185 6.0697c3.9733-3.3626 9.8356-3.2916 13.725 0.16663l-6.9586 7.7263z",
  fill: "#ecaec6"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.32756 0 0 .32545 6.9451 2.9896)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 3.0628
}, React.createElement("path", {
  d: "m24.755 64.277 8.755-30.655 21.214-23.671",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "m12.874 9.524 20.636 24.098"
}), React.createElement("path", {
  d: "m9.411 54.444c-11.448-13.36-9.897-33.472 3.463-44.92s33.471-9.897 44.919 3.463c11.448 13.361 9.898 33.472-3.462 44.92-13.361 11.448-33.472 9.897-44.92-3.463z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var SvgMenuPulseParticipation = function SvgMenuPulseParticipation(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuPulseParticipation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-pulse-participation.6a190a75.svg";
export { ForwardRef as ReactComponent };